export const iconNamesMixin = {
    data() {
        return {
            iconPrefix: 'lnr',

            good: 'icon-check',
            warning: 'icon-warning',
            bad: 'icon-cross-circle',
            offline: 'icon-cloud-crossed',
            alarmSnooze: 'icon-alarm-snooze',
            alarmActive: 'icon-alarm-ringing',
        }
    },
    mounted() {

    },
    methods: {
        buildIcon(icon, classes) {
            return `${this.iconPrefix} ${icon} ${classes}`
        },
    },
    computed: {
        // ----- Alarms -----
        iconAlarmActive() {
            return this.buildIcon('icon-alarm-ringing', 'text-red-500')
        },
        iconAlarmSnoozed() {
            return this.buildIcon('icon-alarm-snooze', 'text-yellow-500')
        },
        iconAlarmResolved() {
            return this.buildIcon('icon-check', 'text-green-500')
        },
        iconAlarmOffline() {
            return this.buildIcon('icon-cloud-crossed', 'text-grey-500')
        },
        iconAlarmThreshold() {
            return this.buildIcon('icon-coolant-temperature', 'text-grey-500')
        },

        // ---- Notification methods ----
        iconEmail() {
            return this.buildIcon('icon-envelope', 'text-gray-500')
        },
        iconSMS() {
            return this.buildIcon('icon-smartphone-notification', 'text-gray-500')
        },
        iconVoiceMail() {
            return this.buildIcon('icon-phone-wave', 'text-gray-500')
        },
        iconPushNotification() {
            return this.buildIcon('icon-cloud-alert', 'text-gray-500')
        },
        iconBubble() {
            return this.buildIcon('icon-bubble', 'text-gray-500')
        },

        // ---- Sorting ----
        iconSortAsc() {
            return this.buildIcon('icon-chevron-up', 'text-grey-500')
        },
        iconSortDesc() {
            return this.buildIcon('icon-chevron-down', 'text-grey-500')
        },

        // ---- Loading / Error ----
        iconLoading() {
            return this.buildIcon('icon-loading', 'text-grey-500 animate-spin ml-3 mr-1')
        },
        iconError() {
            return this.buildIcon('icon-cross', 'text-red-500 mr-1')
        },
        iconRefresh() {
            return this.buildIcon('icon-refresh', 'text-grey-500 mr-1 ml-3')
        },

        // ---- Calibration Certificate ----
        iconCalibrationCertificate() {
            return this.buildIcon('icon-license', 'sonicu-gray')
        },
        iconCalibrationCertificateExpired() {
            return this.buildIcon('icon-license', 'text-yellow-500')
        },

        // ---- Misc ----
        iconWizard() {
            return this.buildIcon('icon-magic-wand', 'text-white')
        },
        iconCompany() {
            return this.buildIcon('icon-city', 'text-gray-500')
        },
        iconDownload() {
            return this.buildIcon('icon-download2', 'text-white')
        },
        iconMapPin() {
            return this.buildIcon('icon-map-marker', 'text-blue-500')
        },
        iconDataLogs() {
            return this.buildIcon('icon-tape2', 'text-blue-500')
        },
        iconAward() {
            return this.buildIcon('icon-medal-first', 'text-gray-500')
        },
    },
}
